import { Tooltip } from '@material-ui/core'
import { useMemo } from 'react'
import { useSampleMetadata } from 'src/api/vcf'
import DnaIcon from 'src/views/AnalysisView/sampleTools/DnaIcon'
import ResultButton from './components/ResultButton'

const AnalysisPopover = ({ fileId, sampleName }) => {
  const sampleMetadata = useSampleMetadata({ fileId: fileId, sampleName })
  const tables = useMemo(() => sampleMetadata.query.data?.tables ?? [], [sampleMetadata.query.data])
  const firstTableId = tables[0]?.id

  // For analyses without sampleName (e.g., Multisample), use simplified URL
  const url = sampleName ? `/libra/variants/${fileId}/${sampleName}/${firstTableId}` : `/libra/variants/${fileId}`

  const handleClick = (e) => {
    // Prevent default only for left click to allow middle click to work normally
    if (e.button === 0) {
      e.preventDefault()
      window.location.href = url
    }
  }

  const handleContextMenu = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(window.location.origin + url)
  }

  // Show button immediately for analyses without sampleName, otherwise wait for table data
  const showButton = sampleName ? firstTableId : true

  return showButton ? (
    <Tooltip title={sampleName ? 'Germline SNV/Indel table' : 'Multisample SNV/Indel table'} arrow>
      <ResultButton primary startIcon={<DnaIcon />} href={url} onClick={handleClick} onContextMenu={handleContextMenu}>
        SNV/Indel
      </ResultButton>
    </Tooltip>
  ) : null
}

export default AnalysisPopover
